<template>
  <div class="container">
    <div class="row">
      <div class="col-12 col-md-10 form-group form-group-sm">
        <label class="label" for="codigoRapipago">Código Rapipago</label>
        <input
          id="codigoRapipago"
          :class="`form-control form-control-sm text-center bg-white`"
          style="cursor: text"
          type="text"
          v-model="codigoRapipago"
        />
      </div>
      <div
        class="col-12 col-md-2 form-group form-group-sm d-flex align-items-end"
      >
        <button class="btn btn-danger" type="button" @click="borrarDatos">
          Borrar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CodigoRapipago",
  props: ["idCobranzaLugarDePago"],
  mouted() {},
  computed: {
    codigoRapipago: {
      get() {
        return this.$store.state.clientes.NuevoCliente.codigoRapipago;
      },
      set(val) {
        this.$store.commit("clientes/NuevoCliente/setCodigoRapipago", val);
      },
    },
  },
  methods: {
    borrarDatos() {
      this.codigoRapipago = null;
    },
  },
};
</script>
